export default {
      id: "about-symbols-03-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-03",
      toString: function () {
        return this.url;
      }
    }